import { useEffect, useState } from "react";

export const useViewport = () => {
  const [dimemsion, setDimension] = useState({
    width: window.innerWidth ?? 0,
    height: window.innerHeight ?? 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setDimension({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return dimemsion;
};

export const useMobileDevice = () => {
  const { width } = useViewport();
  return width < 800;
};
